export default __webpack_public_path__ + "static/media/account-users.31cdc5ca.svg";